import { xs_languageCode } from "..";
import { parseBetsData } from "./parseBetsData";
import { byRanking } from './utils/byRanking';
import { formatDate } from './utils/formatDate';
import { formatDateWithMonth } from './utils/formatDateWithMonth';
import { getBetDescription } from './utils/getBetDescription';
import { getConfiguration } from './utils/configuration';
import { getCurrencyValue } from './utils/getCurrencyValue';
import { getPalAvvFromDesc } from './utils/getPalAvvFromDesc';
import { getSplitDesc } from './utils/getSplitDesc';

function parseBanners(banners) {
    if (banners == null) {
        return [];
    }
    
    const parsedBanners = [];
    banners.forEach(banner => {
        let avvData = null;
        if (banner.avv != null) {
            const match = banner.avv;
            const matchDesc = match.dsl[xs_languageCode];
            const [desc] = getPalAvvFromDesc(matchDesc);
            const [team1, team2] = getSplitDesc(desc);
            const date = formatDateWithMonth(match.ts).dayMonthTime;

            const matchData = {
                alias: match.al,
                avv: banner.a,
                categoryRef: match.ic,
                date: date,
                desc,
                id: match.bid,
                pal: banner.p,
                sportDesc: banner.sportD,
                sportRef: match.is,
                uniqueId: `${match.is}_${match.ic}_${match.it}_${match.bid}`,
                team1,
                team2,
                timestamp : match.ts,
                tournamentDesc: banner.tournamentD,
                tournamentRef: match.it
            };
            const betsData = parseBetsData(matchData, [match.oa], match.oa, match.scs, false, false);
            const bb = match.scs[0];
            if (bb.cs === 0) {
                return
            }

            const bet = betsData.gruppoById[match.oa]?.scommesse?.find(b => b.cs === bb.cs && b.handicap == bb.h) ?? null;
            if (bet == null) {
                console.error(`Scommessa ${bb._cs}_${bb.handicap} non trovata per sport/agg ${match.is}/${match.oa}_$`);
            } else {
                bet.desc = getBetDescription(bet, false);
                bet.odds = bet.odds.filter(o => o.value != null);
                avvData = {
                    ...matchData,
                    bet,
                    bets: [bet]
                };
            }
        }

        parsedBanners.push({
            id: banner.id,
            configId: banner.idc,
            ranking: banner.rnk,
            imageUrl: banner.img,
            url: banner.url,
            text: banner.text,
            pal: banner.p,
            avv: banner.a,
            carouselGroup: banner.carouselGroup,
            avvData
        });
    })
    
    return parsedBanners.sort(byRanking);
}

function parseWinners(winners) {
    const conf = getConfiguration().cs;

    if (winners == null) {
        return  [];
    }

    return winners.map(winner => {
        return {
            name: winner.n,
            betAmount: getCurrencyValue(winner.am, conf.m, conf.nd, conf.ct),
            winnings: getCurrencyValue(winner.wn, conf.m, conf.nd, conf.ct),
            timestampDB: winner.dt,
            date: formatDateWithMonth(winner.dt).dayMonth,
            time: formatDate(winner.dt).time,
        }
    });
}

function parseTopLiveMatches(topLiveMatchesMap) {
    return Object.keys(topLiveMatchesMap);
}

export function parsePageDataAvertising(data) {
    const conf = getConfiguration();
    const currSet = conf.cs;
    
    return {
        carouselBanners: conf.cre && data?.cbs?.car ? parseBanners(data.cbs.car) : null,
        liveMatches: data.les,
        dailyWinnings: getCurrencyValue(data.wd, currSet.m, currSet.nd, currSet.ct),
        weeklyWinnings: getCurrencyValue(data.ww, currSet.m, currSet.nd, currSet.ct),
        recentWinnings: conf.lwe && data.lw? parseWinners(data.lw.wns) : [],
        cart: {
            topBanners: conf.bse && data?.cbs?.rt ? parseBanners(data.cbs.rt) : [],
            bottomBanners: conf.bse && data?.cbs?.rb ? parseBanners(data.cbs.rb) : []
        },
        menu: {
            banners: conf.bse && data?.cbs?.lt ? parseBanners(data.cbs.lt) : []
        }
    };
}

export function parsePageDataAvertisingMobile(data) {
    return {
        carouselBanners: data.cbs ? parseBanners(data.cbs.car) : [],
        eventBanners: data.cbs ? parseBanners(data.cbs.be) : [],
        secondaryBanners: data.cbs ? parseBanners(data.cbs.bs) : [],
        topLiveMatches: data.tlm ? parseTopLiveMatches(data.tlm) : []
    };
}
